export default function init() {
    $('.sidebar-categories').on('click', function(){
        $(this).toggleClass('sidebar-categories__list-wrap--open');
    });
}
